import { Icon } from '../../../layout/Icon.jsx';

/** نافذة بنفس شكل نوافذ الشفتات والديون (card-h + جسم قابل للتمرير). */
export function Modal({ title, sub, onClose, children, footer, width = 560 }) {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4" style={{ background: 'rgba(15,16,18,0.5)' }}>
      <div
        className="bg-white rounded-[14px] shadow-card w-full overflow-hidden max-h-[92vh] flex flex-col"
        style={{ maxWidth: width }}
      >
        <div className="card-h no-print">
          <div className="flex-1">
            <h3 className="text-[15px] font-bold m-0">{title}</h3>
            {sub ? <div className="text-[11.5px] text-ink-3 mt-0.5">{sub}</div> : null}
          </div>
          <button type="button" className="text-ink-3 hover:text-ink" onClick={onClose}>
            <Icon name="x" size={16} />
          </button>
        </div>
        <div className="p-4 space-y-3 overflow-y-auto">{children}</div>
        {footer ? <div className="card-h border-b-0 border-t flex gap-2 no-print">{footer}</div> : null}
      </div>
    </div>
  );
}

export function Row({ label, value, strong, color }) {
  return (
    <div className="flex items-center justify-between text-[13px]">
      <span className="text-ink-3">{label}</span>
      <span className={strong ? 'font-extrabold' : 'font-semibold'} style={color ? { color } : undefined}>
        {value}
      </span>
    </div>
  );
}
